export const MAX_FILTER_COUNT = 6;
export const TRANSITION_PROPERTY_TIMEOUT = 200;
export const COUNT_DEFAULT_FILTERS = 3;
export const COUNT_SELECTED_FILTERS = MAX_FILTER_COUNT - 1; // In design it is set to 6, allowing to configure atleast one filter
export const SPACE_REQUIRED_FOR_DROPDOWN = 300;
export const MIN_COUNT_TO_SEARCH_IN_FILTER_CHIP = 7;

export const UNCHANGED = 'unchanged';
export const ADDED_FILTER = 'Added_Filter';
export const REMOVED_FILTER = 'Removed_Filter';

export const APPLIED_TO_TYPE_AND_ORDER = [
  'User',
  'Role',
  'Account',
  'Entitlement',
];

export const APPLIED_TO_EO_TYPE_AND_ORDER = [
  'Entitlement',
  'Account',
  'Child Entitlement',
];

export const MANUAL_BTNS_FOR_RESPONSIVE_MENU = {
  SMART_FILTER: 'key_for_smart_filter',
  SAVI_FILTER: 'key_for_savi_filter',
  ADD_FILTER: 'key_to_add_filter',
};

export const EXCLUDED_CLASSES_FOR_ACCESIBILITY = [
  'SmartFilter-wrapper',
  'SmartFilter-button',
  'SaviActionsFilter-wrapper',
  'SmartFilterButtonSelect-button',
];
